import Vue from 'vue'
import VueToastr2 from 'vue-toastr-2'
import VueProgressBar from 'vue-progressbar'
import lodash from 'lodash'
import axios_auth from 'axios'
import datePicker from 'vue-bootstrap-datetimepicker'
import cors from 'cors'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import BackToTop from 'vue-backtotop'
import TextareaAutosize from 'vue-textarea-autosize'
import VTooltip from 'v-tooltip'
import InputMask from 'vue-input-mask'
import vSelect from 'vue-select'
import VBodyScrollLock from 'v-body-scroll-lock'

import { mapGetters } from 'vuex'

import App from './App'
import router from './router'
import store from './store'
import axios from './axios.js'
import './filters'

import linkto from './components/link_to'
import orderHistory from './components/orderHistory'
import cart from './components/cart/cart'
import saveError from './components/save_error'
import paginate from './components/paginate'
import loadingSpinner from './components/loadingSpinner'

import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'vue-select/dist/vue-select.css'
import './assets/fontawesome/css/all.css'
import './assets/style.css'

Vue.config.productionTip = false
Vue.use(cors)
Vue.use(VBodyScrollLock)
Vue.use(BackToTop)
Vue.use(TextareaAutosize)
Vue.use(VTooltip)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '40px'
})
Vue.prototype.$moment = moment

window._ = require('lodash')
window.toastr = require('toastr')
toastr.options.progressBar = true
toastr.options.newestOnTop = true
toastr.options.timeOut = 3000
toastr.options.positionClass = 'toast-bottom-left'

Vue.mixin({
  components: {
    linkto,
    datePicker,
    cart,
    saveError,
    Loading,
    orderHistory,
    vSelect,
    paginate,
    InputMask,
    loadingSpinner
  },
  data(){
    return {
      version: 'V1.3',
      //baseURL: 'http://localhost:3016/api',
      baseURL: 'https://office.szivarvanyaqua.hu/api',
      //req_auth: axios_auth.create({baseURL: `https://amulet.szivarvanyaqua.hu/auth`}),
	    // A bejelentkezés az API-n belül van (/api/auth), a külön auth szerviz már nem kell hozzá
	    req_auth: axios_auth.create({baseURL: `https://office.szivarvanyaqua.hu/api/auth`}),
	    //req_auth: axios_auth.create({ baseURL: `http://localhost:3016/api/auth` }),
	    req: axios,
	    toastr_ok: 'Mentés sikeres',
	    toastr_err: 'Mentés sikertelen',
	    load_err: 'Betöltés sikertelen',
      date_options: {
          format: 'YYYY-MM-DD',
          locale: this.$moment.locale('hu')
      },
      date_year_options: {
          format: 'YYYY',
          locale: this.$moment.locale('hu')
      },
      isLoading: false,
      szla_tipusok: [
          { id: 0, nev: 'Minden' },
          { id: 1, nev: 'Készpénz' },
          { id: 2, nev: 'Átutalás' },
          { id: 3, nev: 'Egyéb' },
      ],
      szla_tipusok_search: [
          { id: 0, nev: 'Minden' },
          { id: 1, nev: 'Készpénz' },
          { id: 2, nev: 'Átutalás' },
      ],
      honapok: [
        {honap: 'Január', value: '01'},{honap: 'Február', value: '02'},{honap: 'Március', value: '03'},{honap: 'Április', value: '04'},
        {honap: 'Május', value: '05'},{honap: 'Június', value: '06'},{honap: 'Július', value: '07'},{honap: 'Augusztus', value: '08'},
        {honap: 'Szeptember', value: '09'},{honap: 'Október', value: '10'},{honap: 'November', value: '11'},{honap: 'December', value: '12'}
      ],
      limit: 20,
      regioButtons: [
          {
            start: 1000,
            end: 1999
          },
          {
            start: 2000,
            end: 2999
          },
          {
            start: 5000,
            end: 5999
          },
          {
            start: 6000,
            end: 6999
          },
          {
            start: 7000,
            end: 7999
          },
          {
            start: 8000,
            end: 8999
          }
      ],
      productListTypes: [
        {
          value: 0,
          text: 'Nincs'
        },
        {
          value: 1,
          text: 'Aqua'
        },
        {
          value: 2,
          text: 'Fitrade 1000 ml DRS'
        },
        {
          value: 3,
          text: 'Fitrade 500 ml DRS'
        }
      ],

      managerTypes: [
        {
          value: 1,
          text: 'Admin'
        },
        {
          value: 2,
          text: 'Ügyfélmenedzser'
        },
        {
          value: 3,
          text: 'Kiszállító'
        },
      ]
    }
  },

  created() {
    this.$moment.updateLocale('hu', {
        week: {
            dow: 1
        }
    })
  },

  computed: {
     isAdmin() {
        if(store.getters.user) {
            return store.getters.user.admin == 1
        } else {
            return false
        }
     }
  }
})

new Vue({
  router,
  store,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js